import type { ClubEntriesQueryParams } from "@membentry/shared-types";
import type { QueryClient } from "@tanstack/react-query";
import {
  CLUB_ENTRIES_QUERY_KEY,
  CLUB_MEMBERS_QUERY_KEY,
  CLUBS_QUERY_KEY,
  MY_CLUB_QUERY_KEY,
  MY_CLUBS_QUERY_KEY,
  TODAY_CLUB_ENTRIES_QUERY_KEY,
  getClubByIdQueryKey,
  getClubMembershipQueryKey,
  getMyClubEntriesQueryKey,
  getMyClubTodayEntriesQueryKey,
} from "./queryKeys";

export function invalidateClubs(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: [CLUBS_QUERY_KEY] });
}

export function invalidateClubById(queryClient: QueryClient, id: number) {
  queryClient.invalidateQueries({ queryKey: getClubByIdQueryKey(id) });
}

export function invalidateMyClub(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: [MY_CLUB_QUERY_KEY] });
}

export function invalidateMyClubs(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: [MY_CLUBS_QUERY_KEY] });
}

export function invalidateClubMembers(queryClient: QueryClient, clubId?: number) {
  queryClient.invalidateQueries({
    queryKey: [CLUB_MEMBERS_QUERY_KEY, clubId],
  });
}

export function invalidateClubEntries(queryClient: QueryClient, clubId?: number) {
  queryClient.invalidateQueries({
    queryKey: [CLUB_ENTRIES_QUERY_KEY, clubId],
  });
}

export function invalidateTodayClubEntries(
  queryClient: QueryClient,
  clubId?: number,
) {
  queryClient.invalidateQueries({
    queryKey: [TODAY_CLUB_ENTRIES_QUERY_KEY, clubId],
  });
}

export function invalidateMyClubEntries(
  queryClient: QueryClient,
  params?: Partial<ClubEntriesQueryParams>,
) {
  queryClient.invalidateQueries({
    queryKey: getMyClubEntriesQueryKey(params),
  });
}

export function invalidateMyClubTodayEntries(
  queryClient: QueryClient,
  params?: Partial<ClubEntriesQueryParams>,
) {
  queryClient.invalidateQueries({
    queryKey: getMyClubTodayEntriesQueryKey(params),
  });
}

export function invalidateClubMembership(
  queryClient: QueryClient,
  clubId?: number,
) {
  queryClient.invalidateQueries({
    queryKey: getClubMembershipQueryKey(clubId),
  });
}
